import React, { useState, useEffect, useRef, useContext } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { AppMenu } from './AppMenu';
import { AppProfile } from './AppProfile';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './layout/flags/flags.css';
import './layout/layout.scss';

import { AppTopbar } from './AppTopbar';
import { AuthContext } from './contexts/AuthContext';



const MenuMain = ({children}) => {

    const [layoutMode] = useState('static');
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [filteredMenu, setFilteredMenu] = useState([]);
    const sidebar = useRef();
    const { permissoes } = useContext(AuthContext);

    const history = useHistory();

    let menuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, 'body-overflow-hidden');
        }
        else {
            removeClass(document.body, 'body-overflow-hidden');
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        const menu = [
            { label: 'Romaneios', icon: 'pi pi-microsoft', to: '/romaneio' },
            { label: 'Loja', icon: 'pi pi-shopping-cart', to: '/loja' },
            { label: 'Cotação', icon: 'pi pi-chart-line', to: '/cotacao' },
            { label: 'Boletins', icon: 'pi pi-file', to: '/boletim' },
            { label: 'Pessoas', icon: 'pi pi-users', to: '/pessoa' },
            { label: 'Propriedades', icon: 'pi pi-map-marker', to: '/propriedade' },
            { label: 'Produtos', icon: 'pi pi-id-card', to: '/produto'},
            { label: 'Grupo Produtos', icon: 'pi pi-id-card', to: '/produtoGrupo'},
            { label: 'Pedras', icon: 'pi pi-th-large', to: '/pedra' },
            { label: 'Pesquisa preços', icon: 'pi pi-search', to: '/precos' },
            { label: 'VAF', icon: 'pi pi-dollar', to: '/vaf' },
            { label: 'Estacionamento', icon: 'pi pi-map-marker', to: '/estacionamento' },
            { label: 'Município', icon: 'pi pi-map', to: '/municipio' },
            { label: 'Rotas', icon: 'pi pi-arrow-circle-right', to: '/rotas' },
            { label: 'Permissões', icon: 'pi pi-id-card', to: '/permissoes'},
            { label: 'Logs', icon: 'pi pi-id-card', to: '/logs'}
        ];

        const updatedMenu = menu.filter(item => {
            const key = item.to.replace('/', '');
            return permissoes[key]?.visualizar;
        })

        setFilteredMenu(updatedMenu);
    }, [permissoes]);

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
        menuClick = false;
    }

    const onToggleMenu = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                setOverlayMenuActive(prevState => !prevState);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive(prevState => !prevState);
            }
        }
        else {
            setMobileMenuActive(prevState => !prevState);
        }
        event.preventDefault();
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const isDesktop = () => {
        return window.innerWidth > 1024;
    }

    const isSidebarVisible = () => {
        if (isDesktop()) {
            if (layoutMode === 'static')
                return !staticMenuInactive;
            else if (layoutMode === 'overlay')
                return overlayMenuActive;
            else
                return true;
        }

        return true;
    }


    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
    });

    const sidebarClassName = classNames('layout-sidebar', 'layout-sidebar-light');

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <AppTopbar onToggleMenu={onToggleMenu} />
            <CSSTransition classNames="layout-sidebar" timeout={{ enter: 200, exit: 200 }} in={isSidebarVisible()} unmountOnExit>
                <div ref={sidebar} className={sidebarClassName} onClick={onSidebarClick}>
                    <div className="layout-Logo" style={{ cursor: 'pointer', padding: '10px 10px'}} onClick={() => {
                        history.push('/admin');
                        localStorage.setItem('route', '/admin');
                    }}>
                        <img alt="Logo" src="https://ceasa.patosdeminas.mg.gov.br/static/media/logo_patos.d293b8d1.png" width="100%" height="auto" style={{ maxWidth: '250px' }}/>
                    </div>
                    <AppProfile />
                    <AppMenu model={filteredMenu} onMenuItemClick={onMenuItemClick} />

                </div>

            </CSSTransition>

            <div className="layout-main">
                <div className="p-col-12"  >
                    {children}
                </div>
            </div>

        </div>
    );

}

export default MenuMain;
